import useSWR from 'swr';

import { fetchSegment } from 'src/store/api';

function fetcher(segmentId, options) {
  if (!segmentId) {
    return undefined;
  }
  return fetchSegment(segmentId, options);
}

const defaultConfig = {
  shouldFetch: true,
  revalidateIfStale: false,
  revalidateOnFocus: false,
};

export default function useSegment({ segmentId, options = {}, config = {} }) {
  const { shouldFetch, ...swrConfig } = { ...defaultConfig, ...config };

  const url = `/core/v1/segments/${segmentId}`;

  return useSWR(
    shouldFetch ? { key: url, segmentId, options } : null,
    ({ segmentId: s, options: o }) => fetcher(s, o),
    swrConfig
  );
}
